import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import CloseInCircleIcon from '@icons/CloseInCircleIcon';
import { ItemOption } from '@models/item';
import { OrderOption } from '@models/order';
import useOptionControl from '@store/item/hooks/useOptionControl';
import { pressActionEffect } from '@styles/mixin';
import { useTranslation } from 'react-i18next';

interface Props {
    orderOption: OrderOption;
    itemOption: ItemOption;
    optionGroupId: string;
    itemId: string;
}

function SelectedOptionRow({
    orderOption, itemOption, optionGroupId, itemId,
}:Props) {
    const { t } = useTranslation('item');
    const { optionName, quantity, optionPrice } = orderOption;
    const { removeOption } = useOptionControl({ itemId });
    return (
        <Container fullWidth justify='space-between'>
            <Row spacing={2}>
                <Text>{optionName} ({quantity.toLocaleString()})</Text>
                <Text color={colors.textThird}>
                    {t('option.pricePrefix')}{(optionPrice * quantity).toLocaleString()}{t('footer.priceUnit')}
                </Text>
            </Row>
            <DeleteButton type='button'
                aria-label={optionName}
                onClick={() => removeOption({ option: itemOption, optionGroupId })} >
                <CloseInCircleIcon size={12} color={colors.iconDefault}/>
            </DeleteButton>
        </Container>
    );
}

const Container = styled(Row)`
    padding: var(--spacing-2) 0;
`;

const DeleteButton = styled.button`
    background: none;
    display: flex;
    flex-shrink: 0;
    padding: var(--spacing-0-5);
    ${pressActionEffect}
`;

export default SelectedOptionRow;
